import React from "react";
import "./index.scss";
import { createLabel } from "../../helpers";
import Dropdown from "../../static/Dropdown/Dropdown";
interface RRDropdownProps {
  options?: unknown[];
  value: unknown[];
}

export const RRDropdown = ({ options = [], value }: RRDropdownProps) => {
  return (
    <Dropdown
      onChange={({ url }: any) => {
        location.href = `${location.origin}${url}`;
      }}
      options={createLabel(options)}
      value={createLabel(value)[0]}
    />
  );
};

const RulesRegs = ({ children }: { children: JSX.Element }) => {
  return <div className="rules-regulations">{children}</div>;
};

export default RulesRegs;
